import React from 'react';
import { BentoCard } from './BentoCard';
import { Highlight } from './ui/HeroHighlight';
import { BookCallButton } from './ui/BookCallButton';
export const StatsSection = () => {
  const scrollToCalendly = () => {
    const element = document.getElementById('calendly');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full py-16 sm:py-24" data-id="element-97">
      <div className="max-w-6xl mx-auto px-4 space-y-16 sm:space-y-24" data-id="element-98">
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-black mb-12 sm:mb-16 text-gray-900 text-center" data-id="element-99">
          <Highlight data-id="element-100">Case Studies</Highlight>
        </h2>

        {/* Prolux Energy - Solar */}
        <div data-id="element-101">
          <div className="flex justify-center mb-4" data-id="element-102">
            <div className="bg-gray-900 px-6 py-3 rounded-lg" data-id="element-103">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ivQrgF31cVD9AaxQzFccPX/prolux-energy-whitegoldtransparent.png" alt="Prolux Energy Logo" className="h-12 sm:h-14 md:h-16" data-id="element-104" />
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-105">
            1st Month Results Using
            <br data-id="element-106" />
            <Highlight data-id="element-107">The HIRE Advantage</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-108">
            <div className="md:col-span-2" data-id="element-109">
              <BentoCard title="Projected Added First Year Profit" value="$1,000,000+" subtitle="Added on AUTOPILOT" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-110" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="21" subtitle="In the first 10 Days" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-111" />
            <BentoCard title="Triple-Screened Interviews Booked" value="36" subtitle="In the first 10 days" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-112" />
            <div className="md:col-span-2" data-id="element-113">
              <BentoCard title="Projected ROI in First 90 Days" value="$100,000+" subtitle="More reps = More sales" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-114" />
            </div>
          </div>
        </div>

        {/* Genesis - Our Story */}
        <div data-id="element-115">
          <div className="flex justify-center mb-6 sm:mb-8" data-id="element-116">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/63SDYzLHyNzsKG7PK8z4uG/Screenshot_2025-04-10_at_9.42.53_AM.png" alt="Genesis Logo" className="h-[64px] sm:h-[74px] md:h-[106px] rounded-xl blur-[0.5px]" data-id="element-117" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-118">
            Our D2D Story Using
            <br data-id="element-119" />
            <Highlight data-id="element-120">The HIRE Advantage</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-121">
            <div className="md:col-span-2" data-id="element-122">
              <BentoCard title="Rookie Sales Generated" value="$100M+" subtitle="In just 3 years with our system" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-123" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="2,000+" subtitle="Successfully placed and trained" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-124" />
            <BentoCard title="Our Best Month" value="143" subtitle="New reps in the field" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-125" />
            <div className="md:col-span-2" data-id="element-126">
              <BentoCard title="Number of interviews booked" value="150+" subtitle="per month on average" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-127" />
            </div>
          </div>
        </div>

        {/* Book a Call Button */}
        <div className="flex justify-center" data-id="element-128">
          <BookCallButton onClick={scrollToCalendly} data-id="element-129" />
        </div>

        {/* Life Insurance & Senior Benefits */}
        <div data-id="element-130">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-131">
            Life Insurance & Senior Benefits
            <br data-id="element-132" />
            <Highlight data-id="element-133">Multi-Market Results</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-134">
            <div className="md:col-span-2" data-id="element-135">
              <BentoCard title="Triple-Screened Interviews Booked" value="144" subtitle="Qualified candidates only" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-136" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="101" subtitle="Commission-ready reps" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-137" />
            <BentoCard title="Cost Per Hire" value="$200" subtitle="Efficient recruiting" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-138" />
            <div className="md:col-span-2" data-id="element-139">
              <BentoCard title="Hire Rate" value="70%" subtitle="Quality over quantity" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-140" />
            </div>
          </div>
        </div>

        {/* Windows & Doors - Western US */}
        <div data-id="element-141">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-142">
            Windows & Doors
            <br data-id="element-143" />
            <Highlight data-id="element-144">Western US Expansion</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-145">
            <div className="md:col-span-2" data-id="element-146">
              <BentoCard title="New Revenue Added" value="$2M+" subtitle="Revenue detached from internal bandwidth" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-147" />
            </div>
            <BentoCard title="Triple-Screened Interviews Booked" value="388" subtitle="Market-specific campaigns" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-148" />
            <BentoCard title="Full Commission Reps Hired" value="250+" subtitle="Successfully placed" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-149" />
            <div className="md:col-span-2" data-id="element-150">
              <BentoCard title="Hire Rate" value="64%" subtitle="Blueprint for opening 3 new markets" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-151" />
            </div>
          </div>
        </div>

        {/* Book a Call Button */}
        <div className="flex justify-center" data-id="element-152">
          <BookCallButton onClick={scrollToCalendly} data-id="element-153" />
        </div>

        {/* Windows - Western US (Competitive Market) */}
        <div data-id="element-154">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-155">
            Windows
            <br data-id="element-156" />
            <Highlight data-id="element-157">Competitive Market Success</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-158">
            <div className="md:col-span-2" data-id="element-159">
              <BentoCard title="Triple-Screened Interviews Booked" value="159" subtitle="In crowded markets" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-160" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="93" subtitle="Quality candidates" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-161" />
            <BentoCard title="New Markets Launched" value="1" subtitle="Strategic expansion" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-162" />
            <div className="md:col-span-2" data-id="element-163">
              <BentoCard title="Hire Rate" value="58%" subtitle="Out-structured the competition" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-164" />
            </div>
          </div>
        </div>

        {/* Telecom - California */}
        <div data-id="element-165">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-166">
            Telecom
            <br data-id="element-167" />
            <Highlight data-id="element-168">California Market</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-169">
            <div className="md:col-span-2" data-id="element-170">
              <BentoCard title="Triple-Screened Interviews Booked" value="48" subtitle="Spear-fishing, not casting nets" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-171" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="43" subtitle="Serious candidates only" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-172" />
            <BentoCard title="Hire Rate" value="89%" subtitle="Quality over quantity" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-173" />
            <div className="md:col-span-2" data-id="element-174">
              <BentoCard title="Achievement" value="Preferred Source" subtitle="Highest interview-to-hire conversion in company history" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-175" />
            </div>
          </div>
        </div>

        {/* Book a Call Button */}
        <div className="flex justify-center" data-id="element-176">
          <BookCallButton onClick={scrollToCalendly} data-id="element-177" />
        </div>

        {/* Roofing - Atlanta */}
        <div data-id="element-178">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-179">
            Roofing
            <br data-id="element-180" />
            <Highlight data-id="element-181">Atlanta Market</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-182">
            <div className="md:col-span-2" data-id="element-183">
              <BentoCard title="Triple-Screened Interviews Booked" value="86" subtitle="High-volume engine" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-184" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="57" subtitle="Ready for storm season" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-185" />
            <BentoCard title="Cost Per Hire" value="$225" subtitle="Efficient recruiting" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-186" />
            <div className="md:col-span-2" data-id="element-187">
              <BentoCard title="Hire Rate" value="66%" subtitle="Smoother onboarding = faster first deals" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-188" />
            </div>
          </div>
        </div>

        {/* Community Solar - Midwest */}
        <div data-id="element-189">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-190">
            Community Solar
            <br data-id="element-191" />
            <Highlight data-id="element-192">Rural Midwest Success</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-193">
            <div className="md:col-span-2" data-id="element-194">
              <BentoCard title="Interviews Per Month" value="50" subtitle="In rural territories" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-195" />
            </div>
            <BentoCard title="Hires Per Month" value="35+" subtitle="Consistent results" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-196" />
            <BentoCard title="Cost Per Hire" value="$250" subtitle="Efficient recruiting" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-197" />
            <div className="md:col-span-2" data-id="element-198">
              <BentoCard title="Hire Rate" value="70%" subtitle="Consistent hiring in rural zones" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-199" />
            </div>
          </div>
        </div>

        {/* Book a Call Button */}
        <div className="flex justify-center" data-id="element-200">
          <BookCallButton onClick={scrollToCalendly} data-id="element-201" />
        </div>

        {/* Roofing & Property Restoration - Colorado */}
        <div data-id="element-202">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-203">
            Roofing & Property Restoration
            <br data-id="element-204" />
            <Highlight data-id="element-205">100% Commission Model</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-206">
            <div className="md:col-span-2" data-id="element-207">
              <BentoCard title="Triple-Screened Interviews Booked" value="60" subtitle="Hunter mindset only" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-208" />
            </div>
            <BentoCard title="Hunter Hires" value="33" subtitle="Performance-driven reps" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-209" />
            <BentoCard title="Base Salary Overhead" value="$0" subtitle="Zero overhead" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-210" />
            <div className="md:col-span-2" data-id="element-211">
              <BentoCard title="Hire Rate" value="55%" subtitle="Immediate profitability per hire" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-212" />
            </div>
          </div>
        </div>

        {/* Deregulated Energy - Northeast */}
        <div data-id="element-213">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-214">
            Deregulated Energy
            <br data-id="element-215" />
            <Highlight data-id="element-216">Northeast Expansion</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-217">
            <div className="md:col-span-2" data-id="element-218">
              <BentoCard title="Interviews Per Month" value="20" subtitle="Optimized messaging" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-219" />
            </div>
            <BentoCard title="Hires Per Month" value="15" subtitle="Consistent pipeline" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-220" />
            <BentoCard title="New Markets Launched" value="2" subtitle="Strategic expansion" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-221" />
            <div className="md:col-span-2" data-id="element-222">
              <BentoCard title="Hire Rate" value="75%" subtitle="Data-driven iteration" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-223" />
            </div>
          </div>
        </div>

        {/* Book a Call Button */}
        <div className="flex justify-center" data-id="element-224">
          <BookCallButton onClick={scrollToCalendly} data-id="element-225" />
        </div>

        {/* Remodeling - North Carolina */}
        <div data-id="element-226">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-227">
            Remodeling
            <br data-id="element-228" />
            <Highlight data-id="element-229">North Carolina Scale</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-230">
            <div className="md:col-span-2" data-id="element-231">
              <BentoCard title="Triple-Screened Interviews Booked" value="80" subtitle="Automated grunt work" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-232" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="59" subtitle="Quality over speed" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-233" />
            <BentoCard title="New Markets Launched" value="1" subtitle="Strategic expansion" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-234" />
            <div className="md:col-span-2" data-id="element-235">
              <BentoCard title="Hire Rate" value="73%" subtitle="Quadrupled hiring capacity" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-236" />
            </div>
          </div>
        </div>

        {/* Roofing - Nationwide (PE-Backed) */}
        <div data-id="element-237">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-gray-900 text-center" data-id="element-238">
            Roofing
            <br data-id="element-239" />
            <Highlight data-id="element-240">Nationwide PE-Backed Growth</Highlight>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-241">
            <div className="md:col-span-2" data-id="element-242">
              <BentoCard title="Triple-Screened Interviews Booked" value="200+" subtitle="10 markets staffed" colors={['#2c3a80', '#1e2a66', '#0a1445']} delay={0.2} data-id="element-243" />
            </div>
            <BentoCard title="Full Commission Reps Hired" value="100+" subtitle="Storm season ready" colors={['#1e2a66', '#0a1445', '#2c3a80']} delay={0.4} data-id="element-244" />
            <BentoCard title="Markets Staffed" value="10" subtitle="Nationwide scale" colors={['#0a1445', '#2c3a80', '#1e2a66']} delay={0.6} data-id="element-245" />
            <div className="md:col-span-2" data-id="element-246">
              <BentoCard title="Hire Rate" value="50%+" subtitle="Centralized recruiting HQ" colors={['#2c3a80', '#0a1445', '#1e2a66']} delay={0.8} data-id="element-247" />
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-248">
          <BookCallButton onClick={scrollToCalendly} data-id="element-249" />
        </div>
      </div>
    </div>;
};